/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Barcode from "react-barcode";

import Modal from "../components/Modal";

import { useModalStore } from "../stores/hooks";

function ConvenienceBarcodeModal({ delivery }) {
  const { closeModal } = useModalStore();

  const handleCancel = () => {
    closeModal();
  };

  return (
    <Modal>
      <div className="p-15">
        <div className="mb-20 w-full convenience-barcode">
          {delivery.freshBarcode && (
            <Barcode value={delivery.freshBarcode} format="CODE128" />
          )}
          {/* <div className="text-center text-16 mt-10">
            {delivery.freshBarcode}
          </div> */}
        </div>
        <div className="flex justify-center items-center">
          <button
            type="button"
            className="text-16 flex-1 p-10"
            onClick={handleCancel}
          >
            닫기
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ConvenienceBarcodeModal;
